import { motion } from "framer-motion";
import '../styles/results.scss'

const Results = ({makaiOne, makaiTwo, makaiThree, zhpOne, zhpTwo, zhpThree, voteTotal}) => {
    return(
        <div className="votes-container">
            <h1 className="votes-header title">Voting has ended</h1>
            <p className="title" style={{minWidth: "700px"}}></p>
            <div className="title-wrapper">
                <h1 className="makai">
                    Makai Kingdom Votes
                </h1>
            </div>
            <div className="results" style={{color: "white"}}>
                <div className="poll">
                    <img src="./img/covers/1.png" alt="Makai Cover 1" className="poll-cover"/>
                    <div className="poll-wrapper">
                        <div className="bar" style={{width: `${makaiOne/voteTotal*100}%`}}>{makaiOne}</div>
                    </div>
                </div>
                <div className="poll">
                    <img src="./img/covers/2.png" alt="Makai Cover 1" className="poll-cover"/>
                    <div className="poll-wrapper">
                        <div className="bar" style={{width: `${makaiTwo/voteTotal*100}%`}}>{makaiTwo}</div>
                    </div>
                </div>
                <div className="poll">
                    <img src="./img/covers/3.png" alt="Makai Cover 1" className="poll-cover"/>
                    <div className="poll-wrapper">
                        <div className="bar" style={{width: `${makaiThree/voteTotal*100}%`}}>{makaiThree}</div>
                    </div>
                </div>
            </div>
            <div className="title-wrapper">
                <h1 className="zhp">
                    ZHP Votes
                </h1>
            </div>
            <div className="results" style={{color: "white"}}>
            <div className="poll">
                    <img src="./img/covers/4.png" alt="ZHP Cover 1" className="poll-cover"/>
                    <div className="poll-wrapper">
                        <div className="bar red" style={{width: `${zhpOne/voteTotal*100}%`}}>{zhpOne}</div>
                    </div>
                </div>
                <div className="poll">
                    <img src="./img/covers/5.png" alt="ZHP Cover 2" className="poll-cover"/>
                    <div className="poll-wrapper">
                        <div className="bar red" style={{width: `${zhpTwo/voteTotal*100}%`}}>{zhpTwo}</div>
                    </div>
                </div>
                <div className="poll">
                    <img src="./img/covers/6.png" alt="ZHP Cover 3" className="poll-cover"/>
                    <div className="poll-wrapper">
                        <div className="bar red" style={{width: `${zhpThree/voteTotal*100}%`}}>{zhpThree}</div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Results;